import * as emoji from 'node-emoji';
import ApplicationController from './application_controller';

// Connects to data-controller="text"
export default class extends ApplicationController {
  static targets = ['input', 'output'];

  connect() {
    super.connect();
  }

  render() {
    const inputTag = this.inputTarget.tagName.toLowerCase();
    const outputTag = this.outputTarget.tagName.toLowerCase();

    const inputValue = (inputTag === 'input' || inputTag === 'textarea')
      ? this.inputTarget.value
      : this.inputTarget.innerText;

    const result = emoji.emojify(inputValue);

    if (outputTag === 'input' || outputTag === 'textarea') {
      this.outputTarget.value = result;
    } else {
      this.outputTarget.innerText = result;
    }
  }
}
